import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

const Footer = () => {
  return (
    <Flex
      as="footer"
      bg="surface"
      color="textSecondary"
      borderTopWidth="1px"
      borderColor="borderPrimary"
      w="100%"
      py="2"
      justify="center"
      align="center"
    >
      <Text fontSize="sm">© {new Date().getFullYear()} Schedule Nogle. Todos os direitos reservados.</Text>
    </Flex>
  );
};

export default Footer;
